const config = {
  API_URL: process.env.NODE_ENV === 'production'
    ? ''  // Production: same origin — the API is served by Vercel serverless functions under /api
    : 'http://localhost:5001'  // Development URL
};

console.log('Current API URL:', config.API_URL);
console.log('Current environment:', process.env.NODE_ENV);

export default config;
